module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/chitfund/chitfund.component.css
// module id = ./src/app/chitfund/chitfund.component.css
// module chunks = main